import * as React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress/LinearProgress';


//TODO: @ml/components

export interface IIFProps {
    children: any;
    /** Indicate whether we are loading to display a spinner, assumed to be not */
    loading?: boolean,
    show: boolean,
    else?: JSX.Element | string
}

/**
 * Show a single child if the children is a single element
 * @param props
 */
export const Iif = (props: IIFProps) => {
    if (props.loading) return <LinearProgress />;
    if (props.show) return <>{props.children}</>;
    if (props.else) return <>{props.else}</>;
    return null;
}


// WEBPACK FOOTER //
// ./src/components/iif.tsx